import { render, staticRenderFns } from "./SignupPageWithTab.vue?vue&type=template&id=505b8074&"
import script from "./SignupPageWithTab.vue?vue&type=script&lang=ts&"
export * from "./SignupPageWithTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports